import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdBanner = ({ placement = "homepage" }) => {
  const [ad, setAd] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAd = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${API}/ads/placement/${placement}`);
        const ads = response.data || [];
        
        if (ads.length === 0) {
          setAd(null);
          setLoading(false);
          return;
        }
        
        // Select ad based on priority weighting
        const totalWeight = ads.reduce((sum, ad) => sum + (ad.priority || 1), 0);
        let random = Math.random() * totalWeight;
        
        for (const adItem of ads) {
          random -= (adItem.priority || 1);
          if (random <= 0) {
            setAd(adItem);
            setLoading(false);
            return;
          }
        }
        
        // Fallback to first ad
        setAd(ads[0]);
      } catch (error) {
        console.error("Error fetching ad:", error);
        setAd(null);
      } finally {
        setLoading(false);
      }
    };

    fetchAd();
  }, [placement]);

  const handleClick = async () => {
    if (!ad) return;
    
    // Track click
    try {
      await axios.post(`${API}/ads/click/${ad.id}`);
    } catch (error) {
      console.error("Error tracking ad click:", error);
    }

    // Navigate if link exists
    if (ad.link_url) {
      if (ad.link_url.startsWith('http')) {
        window.open(ad.link_url, "_blank", "noopener,noreferrer");
      } else {
        window.location.href = ad.link_url;
      }
    }
  };

  // Don't render anything if no ad or still loading
  if (loading || !ad) {
    return null;
  }

  // Determine size based on ad settings or defaults
  const adHeight = ad.height || 'auto';
  const adWidth = ad.width || '100%';
  const isFullWidth = placement.includes('homepage') || placement === 'all_pages' || ad.full_width;

  return (
    <section 
      data-testid={`ad-banner-${placement}`}
      className={`${isFullWidth ? 'w-screen relative left-1/2 right-1/2 -mx-[50vw]' : 'w-full'} bg-black flex justify-center`}
    >
      <div
        onClick={handleClick}
        className={`relative ${ad.link_url ? 'cursor-pointer hover:opacity-90 transition-opacity' : ''} w-full max-w-[1920px]`}
      >
        <img
          src={ad.image_url}
          alt={ad.name}
          className="w-full object-cover"
          style={{ 
            height: adHeight === 'auto' ? 'auto' : `${adHeight}px`,
            maxHeight: '400px',
            minHeight: '60px'
          }}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
        
        {/* Ad indicator */}
        <span className="absolute top-2 right-2 text-[8px] font-bold uppercase tracking-widest text-white/50 bg-black/50 px-1.5 py-0.5">
          AD
        </span>
      </div>
    </section>
  );
};

export default AdBanner;
